import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classNames from 'classnames';
import * as React from 'react';
import * as sliderStyles from '../Slider/Slider.css';
import * as styles from './Overlay.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Overlay = function Overlay(_ref) {
  var _classNames;

  var _ref$hideable = _ref.hideable,
      hideable = _ref$hideable === void 0 ? true : _ref$hideable,
      children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles['container'], (_classNames = {}, _defineProperty(_classNames, styles['container--hideable'], hideable), _defineProperty(_classNames, sliderStyles['overlay'], hideable), _classNames)),
    children: children
  });
};